module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_1.62b92519.jpg";